import { connect } from "react-redux";
import ArrowGoBack from "../../../components/ArrowGoBack/ArrowGoBack";
import { useEffect, useState } from "react";
import styles from "./index.module.css";
import DevicesTable from "./devices_table";
import { useNavigate, useParams } from "react-router-dom";
import {
  closeLoading,
  openLoading,
} from "../../../components/loadingModal/loading";
import moment from "moment";
import { getLicensesDetails } from "../../../actions/licenseAction";
import alert from "../../../components/AlertModal/alertModal";
import devicesIcon from "../../../assets/icons/navbar/Devices@4x.png";
import CircleBadge from "../../../components/CircleBadge";

const Devices = (props) => {
  const { licenses, getLicensesDetails } = props;
  const { licenseId } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({
    devices: [],
    numDevices: 0,
    asignatedDevices: 0,
    product: {},
    dateStart: null,
    dateEnd: null,
    idLicense: null,
  });

  const getInitialData = async (reload) => {
    // Fetch initial data based on selected license
    openLoading();

    // get license by licenseId in array licenses
    if (Array.isArray(licenses) && licenses.length > 0 && !reload) {
      const selectedLicense = licenses.find(
        (license) => String(license.idLicense) === String(licenseId),
      );

      setState(selectedLicense);
    } else {
      try {
        const licenseDetails = await getLicensesDetails(licenseId, {
          order: "asc",
          column: "name",
          deep: "devices",
        });
        setState(licenseDetails);
      } catch (error) {
        alert("Error", error.message);
      }
    }
    closeLoading();
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <div className="box-container">
      <ArrowGoBack />
      <div className={`group-box-entry ${styles.container}`}>
        <div className={styles.header}>
          <div className="close" onClick={() => navigate(-1)} />
          <div className={styles.titleContainer}>
            <div className={styles.iconplustitle}>
              <div className={styles.iconCircle}>
                <img
                  src={devicesIcon}
                  alt="devices icon"
                  className="icon_head"
                />
                <div className={styles.title}>{state.product?.name}</div>
              </div>
              <div className={styles.headerStats}>
                <CircleBadge value={state.asignatedDevices} />
                <span className="total_circle_1_title">DEVICES</span>
              </div>
              <div className={styles.headerStats}>
                <CircleBadge
                  value={
                    state.numDevices > 100 ? (
                      <span className={styles.infinitySymbol}>∞</span>
                    ) : (
                      state.numDevices
                    )
                  }
                />
                <span className="total_circle_1_title">
                  TOTAL <br /> DEVICES
                </span>
              </div>
            </div>
            <div className={styles.subtitle}>
              {moment(state.dateStart).format("MMMM Do YYYY")} -{" "}
              {moment(state.dateEnd).format("MMMM Do YYYY")}
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <DevicesTable
            devices={
              state.devices
                ? state.devices.map((device) => ({
                    ...device,
                    idLicense: state.idLicense,
                  }))
                : []
            }
            callback={getInitialData}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    licenses: state.productsReducer.productsLicenses,
  };
};

export default connect(mapStateToProps, { getLicensesDetails })(Devices);
